import client from './client'
import qs from 'qs'

/*
* params
*   type
*   url
*   data
* */
export default async function (params) {
  const type = params.type ? params.type.toUpperCase() : 'GET'
  const data = params.data || {}
  const headers = params.headers || {}
  const {url} = params
  try {
    if (type === 'GET') {
      const res = await client.get(url, {
        params: data,
        headers,
        paramsSerializer: (params) => {
          return qs.stringify(params, {indices: false})
        }
      })
      return res.data
    } else if (type === 'POST') {
      const res = await client.post(url, data, { headers })
      return res.data
    } else if (type === 'PUT') {
      const res = await client.put(url, data, { headers })
      return res.data
    } else if (type === 'DELETE') {
      const res = await client.delete(url, data, { headers })
      return res.data
    } else if (type === 'PATCH') {
      return client.patch(url, data, { headers })
    }
  } catch (err) {
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/apis/admin-api/apiAsync.js